<template>
  <div class="roll">
    <div class="zz-page roll-index-page">
      <div class="page-content-new flex-box-div">
        <otherHeaderTop
          headerTitle="ROLL房"
          :showBack="true"
          @back="back"
          :showBalanceOne="false"
        ></otherHeaderTop>
        <div class="roll-index-content">
          <div class="page-content-bg" v-show="rollList.length == 0">
            <div class="bg-layer1"></div>
          </div>
          <div class="top-box">
            <div class="left">
              <div
                @click="handleChange(0)"
                :class="[type == 0 ? 'sel' : '']"
                class="roll-type-item"
              >
                进行中
              </div>
              <div
                @click="handleChange(1)"
                :class="[type == 1 ? 'sel' : '']"
                class="roll-type-item"
              >
                已结束
              </div>
            </div>
            <div class="right-search-box">
              <div class="search-input">
                <input
                  type="text"
                  v-model="queryParams.rollName"
                  placeholder="请输入ROLL房名称"
                />
              </div>
              <div class="search-btn" @click="handleserch"></div>
            </div>
          </div>
          <div class="roll-list-content-box" @scroll="scrollEventFn">
            <div class="refresh-content van-pull-refresh">
              <div
                class="van-pull-refresh__track"
                style="transition-duration: 0ms"
              >
                <div
                  @click="handleGo(item.id)"
                  class="roll-item"
                  :class="[item.user_id == 0 ? 'official' : '']"
                  v-for="(item, index) in rollList"
                  :key="index"
                >
                  <div class="ended-mask-box" v-if="item.rollStatus == 1">
                    <div class="ended-text">已结束</div>
                  </div>
                  <!-- <div class="ended-mask-box" v-if="item.rollStatus == 0">
                    <div class="ended-text">进行中</div>
                  </div> -->
                  <!-- <div class="ended-mask-box" v-if="item.state == -2">
                    <div class="ended-text">未通过</div>
                  </div> -->
                  <!-- <div class="roll-type">
                    <span v-if="item.rollType == 0">官方</span>
                    <span v-else>推广</span>
                  </div> -->
                  <div class="top">
                    <div class="avatar">
                      <img
                        :src="JSON.parse(item.ornamentsList)[0].imgUrl"
                        alt=""
                      />
                    </div>
                    <div class="name text-ellipsis">{{ item.rollName }}</div>
                    <!-- 参加人数 -->
                    <div class="people-num">
                      {{ item.currentPeopleNum }}人参与
                    </div>
                  </div>
                  <div class="bottom-info-box">
                    <div class="prod-img">
                      <img
                        :src="
                          JSON.parse(item.ornamentsList)[0].imgUrl
                            ? JSON.parse(item.ornamentsList)[0].imgUrl
                            : '../../assets/images/pay_size_sel7.png'
                        "
                        mode="aspectFit"
                        alt=""
                      />
                    </div>
                  </div>
                  <!-- 小的饰品 -->
                  <div class="skins-info">
                    <div
                      class="prod-img"
                      v-for="(item, index) in JSON.parse(item.ornamentsList).splice(0, 3)"
                      :key="index"
                    >
                      <img :src="item.imgUrl" alt="" />
                    </div>
                     <!-- 饰品价值 -->
                     <div class="skins-value">
                      <img src="@/assets/home/jinbi.png" alt="">
                      {{ item.totalOrnamentsPrice }}
                    </div>
                  </div>
                  <!-- 结束时间 -->
                  <div class="end-time">
                    {{ item.endTime }}
                  </div>
                </div>

                <div
                  v-if="rollList.length == 0"
                  style="width: 100%; margin-top: 30%"
                >
                  <div class="no-data">
                    <div class="empty-box-new"></div>
                    <div class="tip-text">暂无信息</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-filter-box">
          <div
            :class="[
              'tab-wrap',
              curTab == 0
                ? 'tab-wrap0'
                : curTab == 1
                ? 'tab-wrap1'
                : curTab == 2
                ? 'tab-wrap2'
                : '',
            ]"
          >
            <div
              @click="handletype(0)"
              :class="[curTab == 0 ? 'sel' : '']"
              class="tab-item"
            >
              <span> 官方 </span>
            </div>
            <div
              @click="handletype(1)"
              :class="[curTab == 1 ? 'sel' : '']"
              class="tab-item"
            >
              <span> 主播 </span>
            </div>
            <div
              @click="handletype(2)"
              :class="[curTab == 2 ? 'sel' : '']"
              class="tab-item"
            >
              <span> 我参与的 </span>
            </div>
          </div>
        </div>
      </div>
      <!---->
    </div>
  </div>
</template>

<script>
import otherHeaderTop from "@/components/otherHeaderTop.vue";
import { getRollList, getUserInfo } from "@/api/index";
export default {
  components: {
    otherHeaderTop,
  },
  data() {
    return {
      type: 0,
      queryParams: {
        rollType: 0,
        rollStatus: 0,
        pageNum: 1,
        pageSize: 10,
        rollName: "",
        userId: "",
      },
      rolllength: "加载中",
      rollList: [],
      isloading: true,
      daqweq: "roll",
      isOver: "加载中",
      // 新的
      safe_top: this.$store.safe_top,
      lists: [],
      page: 1,
      limit: 10,
      isAll: true,
      curTab: 0,
      status: 1,
      state: [-2, 2, -1],
      name: "",
      user: {},
      // 我参与的
    };
  },
  mounted() {
    this.getlist();
  },
  computed: {},
  activated() {
    this.$soundStop("indexBgm");
    this.$soundPlay("boxBgm", true);
  },
  methods: {
    back() {
      this.$router.go(-1);
      this.$soundStop("boxBgm");
      this.$soundStop("battleBgm");
      this.$soundPlay("indexBgm", true);
    },
    scroll(e) {
      if (
        e.srcElement.scrollTop + e.srcElement.clientHeight >=
        e.srcElement.scrollHeight
      ) {
        console.log(1);
        if (this.rolllength !== "暂无更多Roll房") {
          this.queryParams.pageNum++;
          setTimeout(() => {
            this.getlist();
          }, 5);
        }
      }
    },
    playAudio() {
      this.$store.commit("playAudio");
    },
    handleilltate() {
      this.$bus.$emit("is_illustrate", true);
      setTimeout(() => {
        this.$bus.$emit("nr_illustrate", "roll");
      }, 100);
    },
    handleGo(res) {
      // localStorage.setItem("rollid", res);
      this.$router.push({
        name: "rolldetial",
        query: {
          id: res,
        },
      });
    },
    handletype(res) {
      this.curTab = res;
      this.rollList = [];
      this.$soundPlay("click");
      this.isOver = "加载中";
      this.queryParams.pageNum = 1;
      if (res == 2) {
        this.queryParams.userId = this.$store.state.USER_INFO.userId;
        this.queryParams.rollStatus = this.type;
        this.queryParams.rollType = "";
      } else {
        this.queryParams.rollType = res;
        this.queryParams.userId = "";
      }
      this.getlist();
    },
    handleserch() {
      this.rollList = [];
      this.queryParams.pageNum = 1;
      this.isOver = "加载中";
      this.getlist();
    },
    // getMyList() {
    //   this.rollList = [];
    //   getUserInfo().then((res) => {
    //     this.queryParams.userId = res.data.data.userId;
    //     this.getlist();
    //     // console.log(res);
    //   });
    //   //  getMyPartRollList().then(res => {
    //   //     this.rollList = res.data.rows;
    //   //     this.isloading = false;
    //   //   });
    // },
    handlemy() {
      this.type = 2;
      this.rollList = [];
      this.queryParams.pageNum = 1;
      this.queryParams.rollStatus = "";
      this.getMyList();
    },
    handleChange(res) {
      this.$soundPlay("click");
      this.type = res;
      this.rollList = [];
      this.isOver = "加载中";
      this.queryParams.rollStatus = res;
      this.getlist();
    },
    getlist() {
      this.isloading = true;
      getRollList(this.queryParams).then((res) => {
        let arr = [];
        arr = res.data.rows;
        this.rollList.push(...arr);
        this.isloading = false;
        if (arr.length < this.queryParams.pageSize) {
          this.isOver = "暂无更多Roll房";
        }
      });
    },
    scrollEventFn(event) {
      const container = event.target;
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight
      ) {
        if (this.isOver == "加载中") {
          this.queryParams.pageNum++;
          setTimeout(() => {
            this.getlist();
          }, 5);
        } else {
          this.$message({
            duration: 1000,
            message: "暂无更多Roll房",
            type: "warning",
            customClass: "log_warning",
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// 新的
.roll {
  --head-height: 14 * 4.2px;
  height: 100%;
}
.roll-index-page{
  margin-top: 4rem;
}

.roll-index-page .roll-index-content {
  // -webkit-box-flex: 1;
  // -webkit-flex: 1;
  // -ms-flex: 1;
  // flex: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  // overflow: hidden;
  position: relative;
  margin-top: 62px;
  height: calc(100vh - 230px);
}

.roll-index-page .roll-index-content .top-box {
  width: 100%;
  height: 14.53 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 1.73 * 4.2px 0 0 5.47 * 4.2px;
  position: absolute;
  top: -60px;
}

.roll-index-page .roll-index-content .top-box .left {
  width: auto;
  height: 8.33 * 4.2px;
  float: left;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}

.roll-index-page .roll-index-content .top-box .left .roll-type-item {
  width: 5rem;
    height: 2rem;
    line-height: 2rem;
  background: url("~@/assets/open/2.png") no-repeat 0 0;
  // background: url("../../assets/images/tab_short.png") no-repeat 0 0;
  background-size: contain !important;
  text-align: center;
  color: #ffffff;
  margin-right: 2.67 * 4.2px;
  font-size: 14px;
}

.roll-index-page .roll-index-content .top-box .left .roll-type-item.sel {
  background: url("~@/assets/open/1.png") no-repeat 0 0;
  // background-size: 21.07 * 4.2px 8.33 * 4.2px;
}

.roll-index-page .roll-index-content .top-box .right-search-box {
  width: 39.87 * 4.2px;
  height: 7.87 * 4.2px;
  // background: url("../../assets/images/k20.png") no-repeat 0 0;
  background: url("~@/assets/roll/9.png") no-repeat 0 0;
  background-size: 39.87 * 4.2px 7.87 * 4.2px;
  float: right;
  margin: 0.67 * 4.2px 5.33 * 4.2px 0 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  font-size: 14px;
}

.roll-index-page .roll-index-content .top-box .right-search-box .search-input {
  width: 30.67 * 4.2px;
  height: 7.87 * 4.2px;
}

.roll-index-page
  .roll-index-content
  .top-box
  .right-search-box
  .search-input
  input {
  width: 100%;
  height: 7.87 * 4.2px;
  text-indent: 2.4 * 4.2px;
  font-size: 2.67 * 4.2px;
  background: transparent;
}

.roll-index-page
  .roll-index-content
  .top-box
  .right-search-box
  .search-input
  input::-webkit-input-placeholder {
  font-size: 2.67 * 4.2px;
}

.roll-index-page
  .roll-index-content
  .top-box
  .right-search-box
  .search-input
  input::-moz-placeholder {
  font-size: 2.67 * 4.2px;
}

.roll-index-page
  .roll-index-content
  .top-box
  .right-search-box
  .search-input
  input::-ms-input-placeholder {
  font-size: 2.67 * 4.2px;
}

.roll-index-page
  .roll-index-content
  .top-box
  .right-search-box
  .search-input
  input::placeholder {
  font-size: 2.67 * 4.2px;
}

.roll-index-page .roll-index-content .top-box .right-search-box .search-btn {
  width: 8.8 * 4.2px;
  height: 7.87 * 4.2px;
  background: url("../../assets/images/search-icon.png") no-repeat 0 center;
  background-size: 6.67 * 4.2px 6.27 * 4.2px;
}

.roll-index-page .roll-index-content .roll-list-content-box {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  margin-top: 0.2rem;
  height: calc(100vh - 230px);
}

.roll-index-page .roll-index-content .roll-list-content-box .roll-scroll-box {
  width: 100%;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.roll-index-page .roll-index-content .roll-list-content-box .roll-item {
  width: 90%;
  height: 18rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0 auto 2.67 * 4.2px auto;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  border-radius: 8px 8px 8px 8px;
  // border: 1px solid;
  background: url("~@/assets/roll/7.png") no-repeat 0 0;
  background-size: 100% 100%;
}

.roll-index-page
  .roll-index-content
  .roll-list-content-box
  .roll-item.official {
  background: url("../../assets/images/roll_item.png") no-repeat 0 0;
  background-size: 93.47 * 4.2px 27.6 * 4.2px;
}

.roll-index-page
  .roll-index-content
  .roll-list-content-box
  .roll-item.official
  .roll-type {
  background: url("../../assets/images/type_tag_bg.png") no-repeat 0 0;
  background-size: 24.27 * 4.2px 7.47 * 4.2px;
}

.roll-index-page
  .roll-index-content
  .roll-list-content-box
  .roll-item
  .ended-mask-box {
  width: 100%;
  height: 100%;
  // background: url("../../assets/images/end_mask.png") no-repeat 0 0;
  background: #000000a4;
  background-size: 100% 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 5;
}

.roll-index-page
  .roll-index-content
  .roll-list-content-box
  .roll-item
  .ended-mask-box
  .ended-text {
  width: 16 * 4.2px;
  height: 6.13 * 4.2px;
  line-height: 6.4 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  right: 0;
  top: 0;
  text-align: center;
}

.roll-index-page
  .roll-index-content
  .roll-list-content-box
  .roll-item
  .roll-type {
  width: 24.27 * 4.2px;
  height: 7.47 * 4.2px;
  background: url("../../assets/images/k21.png") no-repeat 0 0;
  background-size: 24.27 * 4.2px 7.47 * 4.2px;
  position: absolute;
  top: 5.73 * 4.2px;
  right: 0.53 * 4.2px;
  line-height: 7.47 * 4.2px;
  text-align: center;
  padding-left: 5.33 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 4.4 * 4.2px;
}

.roll-index-page
  .roll-index-content
  .roll-list-content-box
  .roll-item
  .is-join {
  position: absolute;
  width: 13.33 * 4.2px;
  height: 4.8 * 4.2px;
  background: url("../../assets/images/joined.png") no-repeat 0 0;
  background-size: 13.33 * 4.2px 4.8 * 4.2px;
  left: 0;
  bottom: 4.53 * 4.2px;
}

.roll-index-page .roll-index-content .roll-list-content-box .roll-item .top {
  width: 100%;
  height: 6.4 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-top: 2.13 * 4.2px;
  padding-left: 2.4 * 4.2px;
  position: relative;
}
.roll-index-page .roll-index-content .roll-list-content-box .roll-item .top .people-num{
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0.8rem;
  background: linear-gradient( 92deg, #49B6FF 0%, rgba(52,152,240,0.17) 100%);
  border-radius: 1rem 0 0 1rem;
  padding: 0.3rem 0.6rem ;
}

.roll-index-page
  .roll-index-content
  .roll-list-content-box
  .roll-item
  .top
  .avatar {
  width: 6.4 * 4.2px;
  height: 6.4 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  border-radius: 50%;
  background: #fff;
}

.roll-index-page
  .roll-index-content
  .roll-list-content-box
  .roll-item
  .top
  .avatar
  img {
  width: 6.4 * 4.2px;
  height: 6.4 * 4.2px;
  -webkit-border-radius: 3.2 * 4.2px;
  border-radius: 3.2 * 4.2px;
}

.roll-index-page
  .roll-index-content
  .roll-list-content-box
  .roll-item
  .top
  .name {
  width: 57.33 * 4.2px;
  height: 6.4 * 4.2px;
  line-height: 6.4 * 4.2px;
  margin-left: 1.33 * 4.2px;
  font-size: 3.33 * 4.2px;
  text-align: left;
}

.roll-index-page
  .roll-index-content
  .roll-list-content-box
  .roll-item
  .bottom-info-box
  .prod-img {
  // float: left;
  width: auto;
  height: 9rem;
  margin: 0 auto;
  margin-top: -0.4rem;
}

.roll-index-page
  .roll-index-content
  .roll-list-content-box
  .roll-item
  .bottom-info-box
  .prod-img
  img {
  width: 100%;
  height: 100%;
  -o-object-fit: scale-down;
  object-fit: scale-down;
}

.roll-index-page
  .roll-index-content
  .roll-list-content-box
  .roll-item
  .bottom-info-box
  .right-info {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  padding-left: 5.6 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.roll-index-page
  .roll-index-content
  .roll-list-content-box
  .roll-item
  .bottom-info-box
  .right-info
  .time-box {
  width: 100%;
  height: 5.33 * 4.2px;
  line-height: 5.33 * 4.2px;
  font-size: 3.33 * 4.2px;
  text-align: left;
}

.roll-index-page
  .roll-index-content
  .roll-list-content-box
  .roll-item
  .bottom-info-box
  .right-info
  .time-box
  img {
  width: 2.8 * 4.2px;
  height: 3.6 * 4.2px;
  margin-right: 1.47 * 4.2px;
}

.roll-index-page
  .roll-index-content
  .roll-list-content-box
  .roll-item
  .bottom-info-box
  .right-info
  .total-box {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  font-size: 3.33 * 4.2px;
  padding-top: 2.93 * 4.2px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.roll-index-page
  .roll-index-content
  .roll-list-content-box
  .roll-item
  .bottom-info-box
  .right-info
  .total-box
  .total-item {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
}

.roll-index-page
  .roll-index-content
  .roll-list-content-box
  .roll-item
  .bottom-info-box
  .right-info
  .total-box
  .total-item.long-item {
  width: 200%;
}

.roll-index-page
  .roll-index-content
  .roll-list-content-box
  .roll-item
  .bottom-info-box
  .right-info
  .total-box
  .icon-1 {
  width: 4.13 * 4.2px;
  height: 3.73 * 4.2px;
  margin-right: 1.33 * 4.2px;
}

.roll-index-page
  .roll-index-content
  .roll-list-content-box
  .roll-item
  .bottom-info-box
  .right-info
  .total-box
  .icon-2 {
  width: 3.2 * 4.2px;
  height: 3.73 * 4.2px;
  margin-right: 1.87 * 4.2px;
}

.roll-index-page
  .roll-index-content
  .roll-list-content-box
  .roll-item
  .bottom-info-box
  .right-info
  .total-box
  .icon-3 {
  width: 3.2 * 4.2px;
  height: 2.93 * 4.2px;
  margin-right: 1.6 * 4.2px;
  margin-left: 1.33 * 4.2px;
}

.roll-index-page .roll-index-content .roll-list-content-box .empty-div {
  height: 100%;
  width: 100%;
  margin-top: 30%;
}

// .roll-index-page .bottom-filter-box {
//   width: 100%;
//   height: 25.33 * 4.2px;
//   -webkit-box-sizing: border-box;
//   box-sizing: border-box;
//   background: url("../../assets/images/bottom_bg.png") no-repeat left bottom;
//   background-size: 100 * 4.2px 14.53 * 4.2px;
//   position: relative;
// }

.roll-index-page .bottom-filter-box .tab-wrap {
  width: 92.4 * 4.2px;
  height: 14.4 * 4.2px;
  margin: 2.13 * 4.2px 3.87 * 4.2px 0 3.73 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: space-evenly;
  -webkit-justify-content: space-evenly;
  -ms-flex-pack: space-evenly;
  justify-content: space-evenly;
  position: relative;
}

.roll-index-page .bottom-filter-box .tab-wrap .tab-item {
  width: 9rem;
  height: 2.3rem;
  line-height: 2.3rem;
  text-align: center;
  color: #d9d9d9;
  font-size: 1rem;
  position: relative;
  font-family: YouSheBiaoTiHei, YouSheBiaoTiHei;
  font-weight: bold;
  background-size: contain !important;
  background-repeat: no-repeat !important;
}
.roll-index-page .bottom-filter-box .tab-wrap .tab-item.sel span {
  background: linear-gradient(89.99999999998603deg, #feffff 0%, #ffe669 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}
.roll-index-page .bottom-filter-box .tab-wrap .tab-item:nth-child(1) {
  background: url("~@/assets/roll/1.png");
}
.roll-index-page .bottom-filter-box .tab-wrap .tab-item:nth-child(2) {
  background: url("~@/assets/roll/2.png");
}
.roll-index-page .bottom-filter-box .tab-wrap .tab-item:nth-child(3) {
  background: url("~@/assets/roll/3.png");
}
.roll-index-page .bottom-filter-box .tab-wrap .tab-item.sel:nth-child(1) {
  background: url("~@/assets/roll/1-1.png");
}
.roll-index-page .bottom-filter-box .tab-wrap .tab-item.sel:nth-child(2) {
  background: url("~@/assets/roll/2-1.png");
}
.roll-index-page .bottom-filter-box .tab-wrap .tab-item.sel:nth-child(3) {
  background: url("~@/assets/roll/3-1.png");
}
@media only screen and (max-width: 430px) {
  .roll {
    --head-height: 14vw;
  }

  .roll-index-page .roll-index-content .top-box {
    height: 14.53vw;

    padding: 1.73vw 0 0 4.47vw;
  }

  .roll-index-page .roll-index-content .top-box .left {
    height: 9.33vw;
  }

  .roll-index-page .roll-index-content .top-box .left .roll-type-item {
    width: 21.07vw;
    height: 9.33vw;
    line-height: 9.33vw;

    background-size: 21.07vw 9.33vw;

    margin-right: 2.67vw;
  }

  .roll-index-page .roll-index-content .top-box .left .roll-type-item.sel {
    background-size: 21.07vw 9.33vw;
  }

  .roll-index-page .roll-index-content .top-box .right-search-box {
    width: 43.87vw;
    height: 7.87vw;

    background-size: 43.87vw 7.87vw;

    margin: 0.67vw 3.33vw 0 0;
  }

  .roll-index-page
    .roll-index-content
    .top-box
    .right-search-box
    .search-input {
    width: 36.67vw;
    height: 7.87vw;
  }

  .roll-index-page
    .roll-index-content
    .top-box
    .right-search-box
    .search-input
    input {
    width: 100%;
    height: 7.87vw;
    text-indent: 2.4vw;
    // font-size: 2.67vw;
    font-size: 14px;
    color: #fff;
  }

  .roll-index-page
    .roll-index-content
    .top-box
    .right-search-box
    .search-input
    input::-webkit-input-placeholder {
    font-size: 14px;
    color: #fff;
  }

  .roll-index-page
    .roll-index-content
    .top-box
    .right-search-box
    .search-input
    input::-moz-placeholder {
    font-size: 14px;
    color: #fff;
  }

  .roll-index-page
    .roll-index-content
    .top-box
    .right-search-box
    .search-input
    input::-ms-input-placeholder {
    font-size: 14px;
    color: #fff;
  }

  .roll-index-page
    .roll-index-content
    .top-box
    .right-search-box
    .search-input
    input::placeholder {
    font-size: 13px;
    color: #859fc0;
  }

  .roll-index-page .roll-index-content .top-box .right-search-box .search-btn {
    width: 8.8vw;
    height: 7.87vw;

    background-size: 4.67vw 4.67vw;
  }

  .roll-index-page .roll-index-content .roll-list-content-box {
    // margin-top: 6.53vw;
    // height: 65vh;
    height: calc(100vh - 14.53vw - 50.33vw);
  }

  .roll-index-page
    .roll-index-content
    .roll-list-content-box
    .roll-item.official {
    background-size: 93.47vw 27.6vw;
  }

  .roll-index-page
    .roll-index-content
    .roll-list-content-box
    .roll-item.official
    .roll-type {
    background-size: 24.27vw 7.47vw;
  }

  // .roll-index-page
  //   .roll-index-content
  //   .roll-list-content-box
  //   .roll-item
  //   .ended-mask-box {
  //   width: 85.6vw;
  //   height: 27.73vw;

  //   background-size: 85.6vw 27.73vw;
  // }

  .roll-index-page
    .roll-index-content
    .roll-list-content-box
    .roll-item
    .ended-mask-box
    .ended-text {
    width: 16vw;
    height: 6.13vw;
    line-height: 6.4vw;
  }

  .roll-index-page
    .roll-index-content
    .roll-list-content-box
    .roll-item
    .roll-type {
    width: 24.27vw;
    height: 7.47vw;

    background-size: 24.27vw 7.47vw;

    top: 5.73vw;
    right: 0.53vw;
    line-height: 7.47vw;

    padding-left: 5.33vw;

    font-size: 4.4vw;
  }

  .roll-index-page
    .roll-index-content
    .roll-list-content-box
    .roll-item
    .is-join {
    width: 13.33vw;
    height: 4.8vw;

    background-size: 13.33vw 4.8vw;

    bottom: 4.53vw;
  }

  .roll-index-page .roll-index-content .roll-list-content-box .roll-item .top {
    height: 6.4vw;

    margin-top: 2.13vw;
    padding-left: 2.4vw;
  }

  .roll-index-page
    .roll-index-content
    .roll-list-content-box
    .roll-item
    .top
    .avatar {
    width: 6.4vw;
    height: 6.4vw;
  }

  .roll-index-page
    .roll-index-content
    .roll-list-content-box
    .roll-item
    .top
    .avatar
    img {
    width: 6.4vw;
    height: 6.4vw;
    -webkit-border-radius: 3.2vw;
    border-radius: 3.2vw;
  }

  .roll-index-page
    .roll-index-content
    .roll-list-content-box
    .roll-item
    .top
    .name {
    width: 57.33vw;
    height: 6.4vw;
    line-height: 6.4vw;
    margin-left: 1.33vw;
    font-size: 3.33vw;
  }

  .roll-index-page
    .roll-index-content
    .roll-list-content-box
    .roll-item
    .bottom-info-box
    .right-info {
    padding-left: 5.6vw;
  }

  .roll-index-page
    .roll-index-content
    .roll-list-content-box
    .roll-item
    .bottom-info-box
    .right-info
    .time-box {
    height: 5.33vw;
    line-height: 5.33vw;
    font-size: 3.33vw;
  }

  .roll-index-page
    .roll-index-content
    .roll-list-content-box
    .roll-item
    .bottom-info-box
    .right-info
    .time-box
    img {
    width: 2.8vw;
    height: 3.6vw;
    margin-right: 1.47vw;
  }

  .roll-index-page
    .roll-index-content
    .roll-list-content-box
    .roll-item
    .bottom-info-box
    .right-info
    .total-box {
    font-size: 3.33vw;
    padding-top: 2.93vw;
  }

  .roll-index-page
    .roll-index-content
    .roll-list-content-box
    .roll-item
    .bottom-info-box
    .right-info
    .total-box
    .icon-1 {
    width: 4.13vw;
    height: 3.73vw;
    margin-right: 1.33vw;
  }

  .roll-index-page
    .roll-index-content
    .roll-list-content-box
    .roll-item
    .bottom-info-box
    .right-info
    .total-box
    .icon-2 {
    width: 3.2vw;
    height: 3.73vw;
    margin-right: 1.87vw;
  }

  .roll-index-page
    .roll-index-content
    .roll-list-content-box
    .roll-item
    .bottom-info-box
    .right-info
    .total-box
    .icon-3 {
    width: 3.2vw;
    height: 2.93vw;
    margin-right: 1.6vw;
    margin-left: 1.33vw;
  }

  .roll-index-page .bottom-filter-box {
    height: 22.33vw;

    background-size: 100vw 14.53vw;
    position: fixed;
    bottom: 0;
  }

  .roll-index-content {
    height: calc(100vh - 17vw) !important;
  }

  .roll-index-page .bottom-filter-box .tab-wrap {
    width: 92.4vw;
    height: 14.4vw;
    // height: 60px;
    margin: 2.13vw 3.87vw 0 3.73vw;
  }

  // .roll-index-page .bottom-filter-box .tab-wrap1 {
  //   width: 92.4vw !important;
  //   height: 14.4vw !important;
  //   // height: 60px;
  //   margin: 2.13vw 3.87vw 0 3.73vw !important;
  //   background: url('~@/assets/roll/3.png') no-repeat !important;
  //   background-size: 92.4vw 14.53vw !important;
  // }

  .roll-index-page .bottom-filter-box .tab-wrap2 {
    width: 92.4vw !important;
    height: 14.4vw !important;
    // height: 60px;
    margin: 2.13vw 3.87vw 0 3.73vw !important;
    // background: url('~@/assets/roll/4.png') no-repeat !important;
    background-size: 92.4vw 14.53vw !important;
  }

  .roll-index-page .bottom-filter-box .tab-wrap .tab-item::after {
    height: 0.4vw;

    background-size: 28vw 0.4vw;
  }

  // .roll-index-page .bottom-filter-box::before {

  //   width: 100vw;
  //   height: 5.47vw;

  //   top: -5.47vw;

  //   background-size: 100vw 5.47vw;
  // }
}
.page-content-bg .bg-layer1 {
  width: 90%;
  height: 70vh;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(320deg, #05164e 0%, #0b2db4 100%);
  border-radius: 8px 8px 8px 8px;
  border: 1px solid;
  border-image: linear-gradient(
      96deg,
      rgba(179, 223, 255, 1),
      rgba(48, 168, 255, 0),
      rgba(172, 220, 255, 1)
    )
    1 1;
}
.skins-info {
  display: flex;
  position: relative;
}
.skins-info .prod-img {
  width: 3.2rem;
  height: 2.1rem;
  background: #0040a7;
  border-radius: 8px 8px 8px 8px;
  box-sizing: border-box;
  margin: 0 0.4rem;
}
.skins-info .prod-img img {
  height: 100%;
}
.skins-info .skins-value{
  position: absolute;
  right: 1rem;
  top: 0.4rem;
}
.skins-info  .skins-value img {
  width: 1rem;
  height: 1rem;
}
.end-time{
  width: 13rem;
  height: 2.7rem;
  line-height: 2.7rem;
  background: url('~@/assets/roll/roll-btn.png') no-repeat center center;
  background-size: 100% 100%;
  margin: 0 auto;
  margin-top: 1rem;
}
</style>
